import {
  CableSetup,
  Charger,
  CustomerDetails,
  ErrorTypes,
  ProductUrls,
  RegisterInterestRequest,
} from "_core/types";
import { useStore } from "_core/store";
import * as React from "react";
import { registerNewCustomer } from "_core/utils/registerNewCustomer";
import { useConfig } from "_core/utils/config";
import { useCallback } from "react";
import { getChargerId } from "_core/utils/getChargerId";
import { useNavigate } from "react-router";

export const useRegisterNewCustomer = () => {
  const { API_URL } = useConfig();
  const [isLoading, setIsLoading] = React.useState(false);
  const {
    postcode,
    charger,
    utm_campaign,
    utm_medium,
    utm_source,
    cableSetup,
    cableLength,
    baseColour,
  } = useStore();
  const chargerId = getChargerId(charger as Charger, cableSetup as CableSetup);
  const navigate = useNavigate();

  const registerNewCustomerCB = useCallback(
    async <T extends CustomerDetails>(customerDetails: T) => {
      const payload: RegisterInterestRequest = {
        firstName: customerDetails.firstName,
        lastName: customerDetails.lastName,
        email: customerDetails.email,
        telephoneNumber: customerDetails.phoneNumber,
        chargerId: chargerId!,
        postcode: postcode!,
        utm_campaign: utm_campaign || undefined,
        utm_medium: utm_medium || undefined,
        utm_source: utm_source || undefined,
      };
      if (baseColour || cableSetup || cableLength) {
        payload.customisations = {
          cableSetup,
          cableLength,
          baseColour,
        };
      }
      try {
        setIsLoading(true);
        const message = await registerNewCustomer(API_URL, payload);
        switch (message) {
          case "request successful":
            navigate(ProductUrls.PersonalDetailsConfirm);
            break;
        }
        return message;
      } catch (e) {
        setIsLoading(false);
        navigate(ProductUrls.ErrorPage, {
          state: { error: ErrorTypes.OOPS },
        });
      } finally {
        setIsLoading(false);
      }
    },
    [
      chargerId,
      postcode,
      utm_campaign,
      utm_medium,
      utm_source,
      baseColour,
      cableSetup,
      cableLength,
      API_URL,
      navigate,
    ]
  );

  return {
    isLoading,
    registerNewCustomer: registerNewCustomerCB,
  };
};
